module.exports = __webpack_public_path__ + "static/media/egg_plate.29eb412c.png";